/**
 * App paths that only redirect, mapped to the page they land on. The single
 * source for both the redirect routes in `routes.tsx` and the feedback
 * restore, which resolves a stored `page` through {@link resolveAppRedirect}
 * so the restore payload lands on the final page instead of on a redirect
 * route (a redirect hop drops router state and the not-restored notice).
 */
export const APP_REDIRECTS = {
  "/": "/in-season/in-season-review",
  "/pre-season/range-plan": "/assortment/range-plan",
  "/your-access": "/settings/access",
  "/in-season/in-season-forecast/manage-stores": "/settings/in-season",
  "/admin": "/operations/integration-runs"
} as const;

/**
 * A pathname in the form the router matches it: case-insensitive, trailing
 * slash ignored.
 */
export function normaliseAppPath(pathname: string): string {
  return pathname.toLowerCase().replace(/(.)\/+$/, "$1");
}

/**
 * The page a pathname lands on after the app's redirect routes. Matches the
 * way the router does and returns the pathname unchanged when it isn't a
 * redirect.
 */
export function resolveAppRedirect(pathname: string): string {
  const normalised = normaliseAppPath(pathname);
  const redirects: Record<string, string> = APP_REDIRECTS;
  return redirects[normalised] ?? pathname;
}
